 
const icon1 = "https://www.winpeforum.com/assets/elements/SapnaGoyal.png"; 
const icon2 = "https://www.winpeforum.com/assets/elements/AnjaliMahajan.png"; 
const icon3 = "https://www.winpeforum.com/assets/elements/JuhiVasanwala.png"; 
const icon4 = "https://www.winpeforum.com/assets/elements/MalaveekaChakravarthy.png"; 
const icon5 = "https://www.winpeforum.com/assets/elements/Ankita.png"; 
const icon6 = "https://www.winpeforum.com/assets/elements/MitaSood.png"; 
const icon7 = "https://www.winpeforum.com/assets/elements/AradhanaParikh.png"; 
const icon8 = "https://www.winpeforum.com/assets/elements/NehalAgarwal.png"; 
const icon9 = "https://www.winpeforum.com/assets/elements/KrunaliShah.png"; 
const icon10 = "https://www.winpeforum.com/assets/elements/KratiSankhlecha.png"; 
const icon11 = "https://www.winpeforum.com/assets/elements/HemangiDesai.png"; 
const icon12 = "https://www.winpeforum.com/assets/elements/SanchaliHoare.png"; 
const mentConstant5 = [
 
    {
        imgUrl: icon2,
        desc: `Anjali is an Investment Professional at Lighthouse Funds, where she has spent three years in Consumer investing. Before this, she spent four years in Investment Banking at Axis Capital. There, she advised mid-market Indian corporations on their fund-raise endeavours across the focus sectors of Chemicals, Pharma and Lifesciences, Logistics and Manufacturing.
<br/><Br/>
Early in her career, after graduation, she also spent two years in core product design at a global engineering firm’s R&D center. That experience played a significant role in shaping her long-term career direction—it clarified her interest in the business side of decision-making, and eventually led to the transition into finance. Private Equity felt like a natural extension of this journey, allowing deeper involvement in value creation alongside portfolio companies.
 <br/><Br/>
Anjali earned her Bachelor of Technology in Electrical Engineering from NIT Allahabad and MBA from Indian Institute of Management, Kozhikode.

         `,
        name:"Anjali Mahajan",
        company:"Lighthouse Funds",
        post:"Associate Vice President",
         oldpost:" -",
        oldcompany:"-",
        linkedIn:"https://www.linkedin.com/in/anjalim21/",
    },
  {
        imgUrl: icon5,
        desc: `A management consultant with over five years of experience delivering complex, high-impact strategy engagements across smart cities, telecom, technology, retail and healthcare sectors. An accomplished, results-driven MBA with an engineering background, she brings strong capabilities in advanced analytics, structured decision-making and leadership.
<Br/><Br/>
Her experience spans India, South-East Asia and the United States, with functional expertise in business strategy, financial and valuation modelling, market entry strategy, supply chain transformation, operating model design, due diligence and predictive modelling.



         `,
        name:"Ankita Balotia",
        company:"Fireside Ventures",
        post:"Vice President",
        newpost:"-",
        newcompany:"-",
        linkedIn:"https://www.linkedin.com/in/ankita-balotia1792/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in",
    },
      {
        imgUrl: icon7,
        desc: `Aradhana Parikh is a Senior Associate at ChrysCapital, where she contributes to private equity investment execution and portfolio support across key sectors. She brings prior experience as an Investment Associate with Hellman & Friedman and as a consultant at Boston Consulting Group, combining analytical rigour with commercial insight.
<br/><br/>
Aradhana holds an MBA from The Wharton School, University of Pennsylvania, and a Bachelor’s degree in Biology and Economics from the University of Chicago, grounding her investment approach in strong academic foundations and cross-disciplinary perspectives


         `,
        name:"Aradhana Parikh",
        company:"Chrys Capital",
        post:"Senior Associate",
         oldpost:"Partner",
        oldcompany:"AZB & Partners",
        linkedIn:"https://www.linkedin.com/in/aradhana-parikh-249187b3/",
    },
    
    {
        imgUrl: icon11,
        desc: ` 

         `,
        name:"Hemangi Desai",
        company:"Trifecta Capital",
        post:"Associate Director, Credit ",
        oldpost:"Senior Associate",
        oldcompany:"CPP Investments",
        linkedIn:"https://www.linkedin.com/in/hemangi-desai-03065921/",
    },
  {
        imgUrl: icon3,
        desc: ` 

         `,
        name:"Juhi Vasanwala",
        post:"Investment Manager",
        company:"British International Investment",
         oldpost:"Executive Director",
        oldcompany:"Eversource Capital",
        linkedIn:"https://www.linkedin.com/in/juhi-vasanwala/",
    },
    {
        imgUrl: icon10,
        desc: ` 

         `,
        name:"Krati Sankhlecha",
        company:"CPPIB",
        post:"Associate",
         oldpost:"VP",
        oldcompany:"Trifecta Capital",
        linkedIn:"https://www.linkedin.com/in/krati-sankhlecha/",
    },
    {
        imgUrl: icon9,
        desc: `Krunali Shah has been an Investor with A91 Partners for 5 years. She is involved with investments across consumer brands, financial services and technology. Prior to joining A91, Krunali was a part of the Boston Consulting Group. She has graduated from IIM Ahmedabad and is a Chartered Accountant. 


         `,
        name:"Krunali Shah",
        company:"A91 Partners",
        post:"Investor",
         oldpost:"AVP - Compliance",
        oldcompany:"Lighthouse Funds",
        linkedIn:"https://www.linkedin.com/in/krunali-shah-pinjani/",
    },
    {
        imgUrl: icon4,
        desc: ` 
         `,
        name:"Malaveeka Chakravarthy",
        company:"AZB & Partners",
        post:"Partner",
         oldpost:"Senior Specialist Investment & Portfolio Management  ",
        oldcompany:"Accion Emerge",
        linkedIn:"https://www.linkedin.com/in/malaveeka/",
    },

      {
        imgUrl: icon6,
        desc: `Mita started her career at Bharucha & Partners, and focuses on mergers and acquisitions, general corporate and commercial advisory, and employment matters. Her expertise includes advising clients on domestic and offshore acquisitions, ranging from organic joint ventures to venture capital and private equity investments, as well on
litigious investor exits.
<Br/><Br/>
Mita routinely advises clients on a wide range of employment law matters including drafting employment policies, advising on structuring employment incentives, termination of employment for misconduct, and compliance with employment law.




         `,
        name:"Mita Sood",
        company:"Bharucha & Partners ",
        post:"Counsel",
         oldpost:"Vice President",
        oldcompany:"Peak XV",
        linkedIn:"https://www.linkedin.com/in/mita-sood-44b019bb/",
    },
     
    {
        imgUrl: icon8,
        desc: " ",

        name:"Nehal Agarwal",
        company:"British International Investment",
        post:"Investment Executive ",
         oldpost:"Senior Vice President- Investments",
        oldcompany:"Iron Pillar Fund",
        linkedIn:"https://www.linkedin.com/in/nehal-agarwal-24103165/",
    },
     
     {
        imgUrl: icon12,
        desc: ` Sanchali is a private equity professional at Multiples with over 7 years of experience in IB/ PE. During this time, she has been involved in market defining private transactions while having the privilege of partnering with industry pioneers. She enjoys dissecting businesses, understanding risk and partnering in long term value creation. Outside of work you will find her on long leisurely walks, hosting friends at home, working out, travelling or planning her next dive.


         `,
        name:"Sanchali Hoare",
        company:"Multiples Alternate",
        post:"Associate Vice President",
        oldpost:"Senior Associate",
        oldcompany:"CPP Investments",
        linkedIn:"https://www.linkedin.com/in/sanchalihoare/",
    },
    {
        imgUrl: icon1,
        desc: `Sapna Goyal is a seasoned investor with 13+ years of experience in early and growth-stage tech startups in India. At WaterBridge Ventures, she leads early-stage investments in AI and DeepTech. Previously, she led M&A and Strategy at Udaan, where she helped Udaan raise upwards of $800M in capital, looked at new business launches and led various strategic investments. Prior to that, she was a Growth-Stage Investor at Goldman Sachs. Sapna holds an MBA from IIM Kozhikode and a bachelor’s from Lady Shri Ram College. She is passionate about entrepreneurship, technology, and building a more inclusive investment ecosystem.
         `,
        name:"Sapna Goyal",
        company:"WaterBridge Ventures",
        post:"Vice President",
        linkedIn:"https://www.linkedin.com/in/sapna-goyal1/",
    },
 
   
   
    
  
  
   
	
    
,
    
    
    
    
   
    
     
	
]

export default mentConstant5


// WEBPACK FOOTER //
// ./src/constant/mentConstant5.js